import { render, staticRenderFns } from "./QRMPopularStatistic.vue?vue&type=template&id=0ec06d38&"
import script from "./QRMPopularStatistic.vue?vue&type=script&lang=js&"
export * from "./QRMPopularStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports